import React from "react";
import { motion } from "framer-motion";
import villasLocationMap from "../../assets/villas-images/villas-location-map.jpg";

export default function LocationVillas() {
  return (
    <section className="woods-location-section" id="woods-location">
      <motion.div
          initial={{ opacity: 0, y: 45 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.6 }}
      >
        <img
          src={villasLocationMap}
          alt="Vessella Woods location map"
          className="woods-location-iframe"
          loading="lazy"
        />
      </motion.div>
    </section>
  );
}
